<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/index')">首页</a-breadcrumb-item>
      <a-breadcrumb-item>申请成功</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="success-box">
      <div class="success-icon">
        <a-icon type="check-circle" :style="{ fontSize: '80px', color: '#52c41a' }" />
      </div>
      <h2 class="success-title">申请提交成功</h2>
      <p class="success-desc">您的申请已提交，请等待审批</p>

      <div v-if="flowType == '4'" class="special-tips">
        <a-alert
          message="温馨提示"
          description="请在考试开始前打印缓考申请表，前往所在院系及本科生院办理缓考手续"
          type="info"
          show-icon
        />
      </div>

      <div class="action-buttons">
        <a-button type="primary" size="large" @click="goToIndex">返回首页</a-button>
        <a-button size="large" @click="goToList">查看申请列表</a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flowType: ""
    };
  },
  created() {
    this.flowType = this.$route.query.flowType || "";
  },
  methods: {
    goToIndex() {
      this.$router.push({ path: "/index" });
    },
    goToList() {
      this.$router.push({ path: "/sick-leave-list" });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .success-box {
    max-width: 600px;
    margin: 80px auto;
    background: #fff;
    padding: 60px 40px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: center;

    .success-icon {
      margin-bottom: 30px;
    }

    .success-title {
      font-size: 28px;
      color: #333;
      margin-bottom: 15px;
    }

    .success-desc {
      font-size: 16px;
      color: #666;
      margin-bottom: 30px;
    }

    .special-tips {
      margin-bottom: 40px;
      text-align: left;
    }

    .action-buttons {
      .ant-btn {
        width: 180px;
        margin: 0 10px;
      }
    }
  }
}
</style>
